import React, { useCallback, useEffect, useRef, useState } from "react";
import MenuSlider from "./MenuSlider";
import "./MenuSlider.scss";
import { fetchAllRestaurantMenuData, getAllData, getAvailableMenuItems, getAvailableMenus } from "../../../../../../../redux/resturantWidgetSlice";
import { useDispatch, useSelector } from "react-redux";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../utilities/helper";
import { useHistory } from "react-router";
const MenuSliderComponent = () => {
    const company = useSelector((state) => state.companyData.company);
    const { menuData: { storage: { mainMenus } }, menuData, defualtSelectedLocation, organizationID, orderCartData } = useSelector((state) => state.resturantData);
    const [data, setData] = useState(null)
    const [itemsData, setItemsData] = useState(data)
    const [isLoading, setIsLoading] = useState(false)
    const [categories, setCategories] = useState([])
    const [currentIndex, setCurrentIndex] = useState(0);
    const [items, setItems] = useState([]);
    const totalSlides = 7;

    const dispatch = useDispatch()
    const history = useHistory()

    const [selectedItem, setSelectedItem] = useState(null);

    const fetchMenuData = useCallback(() => {
        const userId = localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID);

        dispatch(fetchAllRestaurantMenuData({
            CloudLocationID: company?.LocationID,
            OrganizationID: company?.OrganisationID,
            UserID: localStorage.getItem('isLogged') && localStorage.getItem('isLogged') === 'true' ? userId : "",
            Type: "MENU"
        }));

    }, [dispatch, defualtSelectedLocation, organizationID]);


    useEffect(() => {
        setIsLoading(true)
        fetchMenuData();

    }, []);
    useEffect(() => {
        getAllData().then((result) => {
            setData(result);

        });
    }, [menuData]);
    const handleSelect = (category) => {
        setItems(getCatgoryItems(category?.MenuEntities))
        setSelectedItem(category);
    };
    useEffect(() => {
        if (data) {
            const menuDataObject = data
            let filteredCategories = getAvailableMenus(
                menuDataObject.data.Menu,
                menuDataObject.data.Categories
            )
            let filteredItems = getAvailableMenuItems(
                menuDataObject.data.Items,
                filteredCategories
            )
            const updatedData = {
                ...menuDataObject.data,
                Categories: filteredCategories,
                Items: filteredItems
            };
            setCategories(filteredCategories);
            setSelectedItem(filteredCategories[0]);
            setItems(getCatgoryItems(filteredCategories[0]?.MenuEntities))
            setItemsData(updatedData);
            setIsLoading(false)
        }

    }, [isLoading, data]);
    const getCatgoryItems = (menuEntities) => {
        if (!menuEntities || !Array.isArray(menuEntities) || !itemsData?.Items) return [];
        const menuItemIDs = menuEntities.flatMap(entity => entity.ID);
        const items = itemsData.Items.filter(item => menuItemIDs.includes(item.MenuItemID))?.slice(0, 3);

        return items;
    }

    const nextSlide = () => {
        let idx = currentIndex < totalSlides - 1 ? currentIndex + 1 : 0
        setItems(getCatgoryItems(categories[idx]?.MenuEntities))
        setSelectedItem(categories[idx])
        setCurrentIndex((prevIndex) =>
            prevIndex < totalSlides - 1 ? prevIndex + 1 : 0
        );
    };

    const prevSlide = () => {
        let idx = currentIndex > 0 ? currentIndex - 1 : totalSlides - 1
        setItems(getCatgoryItems(categories[idx]?.MenuEntities))
        setSelectedItem(categories[idx])
        setCurrentIndex((prevIndex) =>
            prevIndex > 0 ? prevIndex - 1 : totalSlides - 1
        );
    };

    return (

        <div className="MenuSlider">
            {!isLoading ? <>
                <div className="MenuSlider-Categories">
                    {categories?.length > 0 &&
                        categories?.slice(0, 7).map((category, key) => {
                            return (
                                <div
                                    className={selectedItem?.MenuCategoryID === category?.MenuCategoryID ? "MenuSlider-Categories-item-selected" : "MenuSlider-Categories-item"}
                                    onClick={() => {
                                        handleSelect(category)
                                    }}
                                    key={key}
                                >{category?.Title?.en}</div>
                            )
                        })
                    }
                </div>

                <MenuSlider items={items}
                    currentIndex={currentIndex}
                    setCurrentIndex={setCurrentIndex}
                    nextSlide={nextSlide}
                    prevSlide={prevSlide} />
                <div className="MenuSlider-button"
                    onClick={() => {
                        history.push("/menu")
                    }}>
                    View Menu
                </div>
            </> : <div className="MenuSlider-loader-btn" />}

        </div>

    )
}
export default MenuSliderComponent